const isMainNavEnabled = false;
export default [
  {
    path: 'rahome',
    name: 'Home',
    component: () => import(/* webpackChunkName: "risk-assessment-home" */ '../views/Home.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'rmview',
    name: 'RM Risk Assessment',
    component: () => import(/* webpackChunkName: "RMview" */ '../views/RMview.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'tmview',
    name: 'TM Assessment GRID',
    component: () => import(/* webpackChunkName: "TMview" */ '../views/TMview.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'tsview',
    name: 'TS Assessment GRID',
    component: () => import(/* webpackChunkName: "TSview" */ '../views/TSview.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'summary',
    name: 'RM Risk Summary Matrix',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/Summary.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'tstmsummary',
    name: 'TS/TM Risk Summary Matrix',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/TSTMSummary.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'actionplan',
    name: 'RM Action Plan',
    component: () => import(/* webpackChunkName: "rm-actionplan" */ '../views/ActionPlan.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'actionplanDashboard',
    name: 'RM Action Plan Dashboard',
    component: () => import(/* webpackChunkName: "rm-actionplan-dashboard" */ '../views/ActionPlanDashboard.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'users',
    name: 'User Management',
    component: () => import(/* webpackChunkName: "admin-users" */ '../views/Admin/Users.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'tsmusers',
    name: 'User Management',
    component: () => import(/* webpackChunkName: "admin-users" */ '../views/Admin/TSMUsers.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'segmentOneMapping',
    name: 'Segment One Mapping',
    component: () => import(/* webpackChunkName: "admin-users" */ '../views/Admin/SegmentOneMapping.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'riskAssessment',
    name: 'Risk Assessment Master',
    component: () => import(/* webpackChunkName: "admin-riskAssessment" */ '../views/Admin/RiskAssessment.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'riskRating',
    name: 'Risk Rating Master',
    component: () => import(/* webpackChunkName: "admin-riskRating" */ '../views/Admin/RiskRating.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    }
  },
  {
    path: 'owners',
    name: 'Material Group Owner Mapping',
    component: () => import(/* webpackChunkName: "admin-owners" */ '../views/Admin/MaterialGroupOwnerMapping.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    }
  },
  {
    path: 'notfound',
    name: 'notfound',
    component: () => import(/* webpackChunkName: "admin-owners" */ '../views/PageNotFound.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    }
  },
  {
    path: 'supplierinputform',
    name: 'Supplier Input Form',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/SupplierInputForm.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'segmentriskonepager',
    name: 'Segment Risk One Pager',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/segmentOnePager.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'deletedrecords',
    name: 'Deleted Records',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/Admin/DeletedRecords.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'suppliermaster',
    name: 'Supplier Master',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/Admin/SupplierMaster.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'segmentcommoditymaster',
    name: 'Segment/Commodity Master',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/Admin/SegmentOrCommodityMaster.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'tsactionplan',
    name: 'TS Action Plan',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/TSActionPlan.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'tmactionplan',
    name: 'TM Action Plan',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/TMActionPlan.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'supplychainriskwatch',
    name: 'Supply Chain Risk Watch',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/supplyChainRiskWatchPager.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'rmmaterialriskmitigation',
    name: 'RM Risk Mitigation One Pager',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/RmMaterialRiskMitigation.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'rmmaterialriskmitigationpbau',
    name: 'RM Risk Mitigation One Pager (PBAU)',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/RmMaterialRiskMitigationForPbau.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'csitview',
    name: 'CS-IT Risk Assessment',
    component: () => import('../views/CSIT/CSITView.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'csitactionplan',
    name: 'CS-IT Action Plan',
    component: () => import('../views/CSIT/CSITActionPlan.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'consultingassessmentview',
    name: 'Consulting Risk Assessment',
    component: () => import('../views/CSIT/CSITViewConsultant.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
     },
  },
  {
    path: 'consultingactionplan',
    name: 'Consulting Action Plan',
    component: () => import('../views/CSIT/CSITActionPlanConsultant.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'csitsummary',
    name: 'CS-IT Summary Matrix',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/CSIT/CSITSummary.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },

  {
    path: 'csitsegmentonepager',
    name: 'Segment One Pager',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/CSIT/CSITsegmentOnePager.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },

  {
    path: 'csitusers',
    name: 'User Management',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/CSIT/Admin/Users.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },

  {
    path: 'csitdeleterecords',
    name: 'Deleted Records',
    component: () => import(/* webpackChunkName: "rm-summary" */ '../views/CSIT/Admin/DeletedRecords.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },

  {
    path: 'csitsegmentmaster',
    name: 'Segment Master',
    component: () => import('../views/CSIT/Admin/SegmentMaster.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },

  {
    path: 'riskparametersmapping',
    name: 'Risk Parameters Mapping',
    component: () => import(/* webpackChunkName: "admin-users" */ '../views/Admin/SegmentOneMapping.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  
  // {
  //   path: 'logout',
  //   name: 'logout',
  //   component: () => import(/* webpackChunkName: "admin-owners" */ '../views/Logout.vue'),
  //   meta: {
  //     mainNavEnabled: isMainNavEnabled,
  //   }
  // }
]
